export const Options =[
    {
      title: "Branding y liderazgo para CEO´s y Top Execs.",
      description: "Nada más cautivador en los negocios que una personalidad natural bien entrenada, tanto para tomar decisiones con la cabeza fría como para liderar con certeza en cualquier situación.",
      imgUrl: "../../assets/images/Jahn-b-0.jpg"
    },
    {
      title: "Biohacking",
      description: "Al integrar a la vida diaria sencillas técnicas wellness y cambio de hábitos, las personas elevan su productividad casi 50%, se mantienen saludables, con altos niveles de energía y mayor resiliencia ante el estrés.",
      imgUrl: "../../assets/images/Jahn-b-1.jpg"
    },
    {
      title: "Xplendor",
      description: "Quien conoce su propósito, le apasiona su trabajo y pule sus fortalezas irradia felicidad que se refleja en su desempeño laboral. Nuestro trabajo es ayudar a encontrar la plenitud.",
      imgUrl: "../../assets/images/Jahn-b-2.jpg"
    },
    {
      title: "Mind hacking",
      description: "Hacer que las cosas sucedan tiene sus secretos: aprender a planear, manejar emociones, comunicar con efectividad y decidir sin titubear. ¿La estrategia? Dominar la mente.",
      imgUrl: "../../assets/images/Jahn-b-3.jpg"
    },
    {
      title: "Coaching de equipo",
      description: "El alto desempeño va de la mano con los ambientes laborales sanos, razón suficiente para propiciar relaciones libres de pugnas y espacios abiertos a la expresión de ideas.",
      imgUrl: "../../assets/images/Jahn-b-4.jpg"
    },
    {
      title: "Certificaciones 'Leader Coach' y 'Mentor Coach'",
      description: "¿Buscas que los líderes de tu organización orienten e inspiren con certeza a sus equipos? Con las herramientas precisas se obtienen resultados impresionantes: mayor autoconfianza, independencia y proactividad, cualidades indispensables para mejorar el desempeño de todos.",
      imgUrl: "../../assets/images/Jahn-b-5.jpg"
    }
];


export const Options_Group =[
  {
    title: "Eleva la productividad ",
    description: "Dispón de soluciones grupales que concilian en corto tiempo las diferencias entre equipos y la falta de comunicación. ¿El resultado? 63% menos rotación, 70% más eficiencia",
    imgUrl: "../../assets/images/Coaching.webp"
  },
  {
    title: "Promueve la confianza ",
    description: "Devuelve el autocontrol a los colaboradores, transmite seguridad a los clientes y mejora tu posicionamiento frente a la competencia",
    imgUrl: "../../assets/images/empresa-wellness-mujer-relajada.webp"
  },
  {
    title: "Supera metas de venta",
    description: "El impacto directo en la facturación de las empresas se refleja de inmediato, gracias a la transformación del personal destacado",
    imgUrl: "../../assets/images/Business-Plan.webp"
  }
];

